export default "__VITE_ASSET__BzkVZhH5__"